
import { PlayerEventType, PlayerEventStateType, PlayerEventSessionType, InstantEventType, TiledEventActionName } from '../model/playerEventModel';
import { gotoPage } from './hubUtil';
import { ACTION_TYPES_UNIVERSAL_PLAYER_EVENT } from '../app/reducers';
import ApplicationEntity from './appEntity';
import { sendDownloadedEvent } from './util';
import MicroAppPagesCollection from './microappView';

export const isNotDocumentSession = (event) => {
    if (event.data && event.data.sessionType) {
        const sessionType = event.data.sessionType;
        return sessionType === PlayerEventSessionType.Image ||
            sessionType === PlayerEventSessionType.Video ||
            sessionType === PlayerEventSessionType.Audio ||
            sessionType === PlayerEventSessionType.URL ||
            sessionType === PlayerEventSessionType.Failed; // the failed type is that the content cannot be properly display by UP, like Excel or Zip
    }

    return false;
};

const isTiledEvent = event => event.instantEventType === InstantEventType.tiledEvent;

const handleMicroAppEvent = (sessionId, event) => {
    if (event.data && event.data.name === TiledEventActionName.visited) {
        const screenId = event.data.screenId;
        const { pageIndex, documentPageIndex } = MicroAppPagesCollection.getInstance().getScreenPageInfo(screenId);

        const metadataMicroApp = {
            ...(event.data),
            documentPageIndex
        };
        gotoPage(sessionId, pageIndex, metadataMicroApp);
    }
};

const gotoPageEvent = (sessionId, event) => {
    const { isMicroApp } = MicroAppPagesCollection.getInstance();

    if (isMicroApp && event.eventType === PlayerEventType.StartSession) {
        return;
    }

    if (isTiledEvent(event)) {
        handleMicroAppEvent(sessionId, event);
    }

    if (event.stateType === PlayerEventStateType.ContentPage) {
        // the page index which return from Universal Player start from one, so here we need minus one
        gotoPage(sessionId, event.state - 1);
    }

    if (event.eventType === PlayerEventType.StartSession && isNotDocumentSession(event)) {
        // for image, video, firestorm and url there is only one page
        gotoPage(sessionId, 0);
    }
};


function savePlayerLastEventToStore(event, args) {
    if (isTiledEvent(event) && !(event.data && event.data.name === TiledEventActionName.visited)) {
        return;
    }

    if (event && args.dispatch) {
        args.dispatch({
            type: ACTION_TYPES_UNIVERSAL_PLAYER_EVENT,
            payload: event
        });
    }
}

const isDownloadEvent = event => event.eventType === PlayerEventType.InstantEvent && event.instantEventType === InstantEventType.download;

const handleGotoPage = (event, args) => {
    if (event.stateType === PlayerEventStateType.ContentPage ||
        (event.eventType === PlayerEventType.StartSession && isNotDocumentSession(event)) || isTiledEvent(event) ||
        isDownloadEvent(event)) {
        savePlayerLastEventToStore(event, args);

        if (args.isOnlyFunctionalCookies) {
            return;
        }

        if (args.isExpired) {
            return;
        }

        // If there is no session we shouldn't go to page since we have opt-out and opt-in optin in Viewer side panel
        if (!ApplicationEntity.getInstance().sessionId) {
            return;
        }

        if (isDownloadEvent(event)) {
            const contentId = ApplicationEntity.getInstance().selectedContentId;
            sendDownloadedEvent(contentId);
            return;
        }

        if (ApplicationEntity.getInstance().sessionId) {
            const sessionId = ApplicationEntity.getInstance().sessionId;
            gotoPageEvent(sessionId, event);
        }
    }
};

export default handleGotoPage;
